import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {articlesList_template} from "../components/templates/articlesList_template";

import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {republishOpportunitiesReport_template} from "../components/templates/republishOpportunitiesReport_template";
import { downloadCSV } from "../../vendor/valnet/valnet_jslib/vnHelpers/helper_functions";

declare var ko: any;
declare var page: any;

export class republish_opportunities_report extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected articlesList: republishOpportunitiesReport_template;
    protected pagination: pagination_template;
    protected viewPageUrl;
    protected timer;

    protected getModuleName(): string{

        return "republish-opportunities";
    }

    buildContent(): Array<Element>{

        // create the article list
        this.articlesList = new republishOpportunitiesReport_template("list", this.viewModel, this);
        this.template = this.articlesList;

        this.viewPageUrl = '/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/view/';

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Republish Opportunities");

        return [this.articlesList.build()];
    }

    public fillPage() : void{

        //this.articlesList.buildDatePickerCalendar();
        this.getListFormData();
    }


    public getListFormData(): void{

        if( "getListFormData" in this.XHRHdls ){
            this.XHRHdls["getListFormData"].cancelAndReset();
        }

        this.loadingIn(this.articlesList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdls['getListFormData'] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdls['getListFormData'].onReadyStateFunction = this.onListFormDataRequestReturn;
        this.XHRHdls['getListFormData'].execute();

    }

    protected onListFormDataRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                //console.log(responseParsed.networkCategories);
                let statuses = [];
                for( let status of responseParsed.statuses){
                    if(status.id != 8){
                        statuses.push(status)
                    }
                }
                obj.articlesList.setIntentFilterItems(responseParsed.intents);
                obj.articlesList.setNetworkCategoryFilterItems(responseParsed.networkCategories);
                obj.articlesList.setContentTypeFilterItems(responseParsed.contentType);
                obj.articlesList.setCategoryFilterItems(responseParsed.categories);
                obj.articlesList.setPermissions(responseParsed.permissions);
                obj.articlesList.setBrand(responseParsed.brand);

                obj.updateViewModelFromPath();

                obj.getSearchPresetsListData();
            });

        }
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.articlesList.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.articlesList.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected addToRepublishQueue(selectedArticles) {

        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.articlesList.builtTemplate.children.namedItem("list-results"));

        let formReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/analytics/republish-opportunities/add/';

        formReq_params.push(["data", JSON.stringify(selectedArticles)] );
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;


        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    obj.exportList(responseParsed.data, responseParsed.brandName);
                    obj.filterList();
                })
            }
        });
        XHRHdl.execute();
    }

    protected addToRepublishDeferral(selectedArticles, daysToDefer) {

        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.articlesList.builtTemplate.children.namedItem("list-results"));

        let formReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/analytics/republish-opportunities/deferral/add/';

        let data = {articles : selectedArticles, daysToDefer : daysToDefer};

        formReq_params.push(["data", JSON.stringify(data) ]);
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;


        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    obj.filterList();
                })
            }
        });
        XHRHdl.execute();
    }

    protected deleteFromRepublishQueue(selectedArticles) {
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.articlesList.builtTemplate.children.namedItem("list-results"));

        let formReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/analytics/republish-opportunities/delete/';

        formReq_params.push(["data", JSON.stringify(selectedArticles)] );
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, responseParsed.data);
                    obj.getVnAppZone().showNotificationToModule();
                    obj.filterList();
                })
            }
        });
        XHRHdl.execute();
    }

    protected deleteFromRepublishDeferral(selectedArticles) {
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.articlesList.builtTemplate.children.namedItem("list-results"));

        let formReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/analytics/republish-opportunities/deferral/delete/';

        formReq_params.push(["data", JSON.stringify(selectedArticles)] );
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, responseParsed.data);
                    obj.getVnAppZone().showNotificationToModule();
                    obj.filterList();
                })
            }
        });
        XHRHdl.execute();
    }

    public exportList(articles, brandName){

        //create CSV
        let data = [];

        //row titles in Excel spreadsheet
        let titles = ["Title","Most Recent Author","Original Author","Emaki Link","Sessions"]

        //Names/keys in json object
        let keys =   ["title", "mostRecentAuthor", "author", "emakiLink", "last30DaySessions"]

        let titleRow = {};
        let row;
        titles.forEach( t => { titleRow[t] = '' })
        data.push(titleRow);

        let domain = (new URL(document.baseURI)).origin;

        for (let article of articles) {

            row = {};

            article.emakiLink = domain + this.viewPageUrl + article["id"] + "/";
            article.mostRecentAuthor = article.republishAuthor != null ? article.republishAuthor : article.author;

            for (let i = 0; i < titles.length; i++) {
                row[titles[i]] = article[keys[i]];
            }

            data.push(row);
        }

        //push empty row
        data.push(titleRow);

        let date = new Date();
        let formattedDate = date.toLocaleDateString('en-GB').split('/').reverse().join('');

        let fileName = "RepublishOpportunities-" + formattedDate + "-" + brandName + ".csv";

        downloadCSV({filename: fileName, data: data});
    }

    protected addArticle(){
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
        this.saveViewModule(this.getMemoryViewModel());
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/add/')
    }

    protected paginationOnPageClick(){

        this.filterList();
    }


    protected filterDateOnChange(){
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange(){
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
    }


    protected filterMultipleSelectorOnChange(){
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }


    protected articlesListReorder(){

        this.filterList();
    }

    protected filterSimpleOnChange(idElement){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    public filterList(){

        // LOADING : starts
        this.loadingIn(this.articlesList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/analytics/republish-opportunities/get/';

        let subViewModel = this.articlesList.getViewModelForRequest();
        this.timer = new Date().getTime();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'republish_opportunities_report');
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });

            obj.loadingOut(obj.articlesList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(responseParsed: any) {

        this.articlesList.setArticles(responseParsed.reportData.data);

        this.articlesList.setIsAllRowsSelected(false);

        let execTime = Math.round((new Date().getTime() - this.timer)/1000*100)/100;
        this.articlesList.setResultInfo(responseParsed.reportData.totalCount, responseParsed.reportData.totalPage,execTime );

        //Update the Paginator
        this.viewModel.list.pagination.itemCount(responseParsed.reportData.totalCount);
    }

    protected getMemoryViewModel(){

        let templateViewModel = this.articlesList.getTemplateViewModel();

        delete templateViewModel.articles;

        return templateViewModel;
    }

    protected getUsersSuggestion(keyword, idElement) {

        if( "getUsersSuggestion" in this.XHRHdls ){
            this.XHRHdls["getUsersSuggestion"].cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}, idElement: idElement};

        //let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getUsersSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getUsersSuggestion'].onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdls['getUsersSuggestion'].execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    if (responseParsed.data.users) {
                        if (responseParsed.data.idElement == "authorFilter") {
                            obj.articlesList.setAuthorFilter(responseParsed.data.users);
                        }else {
                            obj.articlesList.setEditorFilter(responseParsed.data.users);
                        }
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                } else {
                    obj.articlesList.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.articlesList.deactivateLoading();
            }
        }

    }

    protected getTagsSuggestion(keyword, idElement) {

        if( "getTagsSuggestion" in this.XHRHdls ){
            this.XHRHdls["getTagsSuggestion"].cancelAndReset();
        }

        let subViewModel = {filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/tag/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getTagsSuggestion']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getTagsSuggestion'].onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdls['getTagsSuggestion'].execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.tags) {
                    let x = responseParsed.data.idElement;

                    obj.articlesList.setTagFilter(responseParsed.data.tags);
                }

            });
        }
    }

    // search preset section

    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.articlesList.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onPostSearchPresetArticles
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onPostSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.articlesList.addCreatedPresetToList(response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);

            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onPostFavoriteSearchPresetArticles
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onPostFavoriteSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);

            });

        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);
            });
        }
    }

    protected filterByUrl(){
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters){
        this.articlesList.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected setDefaultStatusFilters(){
        this.articlesList.setDefaultStatusFilters();
    }

}


// WEBPACK FOOTER //
// ./js/modules/republish_opportunities_report.ts